<!--
 * @Autor: 
 * @Description: 为你推荐
 * @Date: 2021-07-15 15:46:25
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: 2021-07-22 14:00:35
-->
<template>
  <div v-if="modulesList.firstList.height" class="recommend-list">
    <div class="header-text">
      <img src="https://static.yunjiglobal.com/qnUpload/frontend/commodity/category-nav-new/sub-title-recommend.png" />
      <span>为你推荐</span>
    </div>
    <div 
      class="recommend-list-container"
      v-infinite-scroll="loadBottom" 
      infinite-scroll-immediate-check="true" 
      infinite-scroll-disabled="loading" 
      infinite-scroll-distance="10"
    >
      <div class="row-container">
        <div 
          v-for="(item, index) in modulesList.firstList.list"
          :key="index"
        >
          <good-card 
            class="item-container" 
            v-if="item.type === 0" 
            :itemData="item"
            :index="item.$index"
            @toDetail="toDetail"
          />
        </div>
      </div>
      <div class="row-container">
        <div 
          v-for="(item, index) in modulesList.secondList.list"
          :key="index"
        >
          <good-card 
            class="item-container" 
            v-if="item.type === 0" 
            :itemData="item"
            :index="item.$index"
            @toDetail="toDetail"
          />
        </div>
      </div>
    </div>
    <div v-if="!hasMore" class="more-text">没有更多了</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { InfiniteScroll } from 'mint-ui'
import { createNamespacedHelpers } from 'vuex'
import * as service from '@/pages/commodity/api/category-new'
import YunJi from '@/assets/js/YunJi'
import GoodCard from './GoodCard.vue'
import { createTrackObj, jumpHandle, createTrackContentIdList } from '../util'
import * as MarkeUtil from '@/pages/commodity/common/MarkeLabelUtil'

Vue.use(InfiniteScroll)

const { mapState, mapMutations } = createNamespacedHelpers('categoryNav')

// 0商品 1店铺 2榜单 3专题
const itemHeight = [220, 210, 210, 209]

export default {
  name: 'recommend-list',
  components: {
    GoodCard
  },
  computed: {
    ...mapState(['categoryId', 'parentLevelName', 'shopId'])
  },
  watch: {
    'categoryId'() {
      this.moduleLeave()
      this.initData()
      this.queryPageModuleTabRecommend()
    }
  },
  data() {
    return {
      modulesDataList: [],
      hasMore: true,
      modulesList: {
        firstList: {
          height: 0,
          list: []
        },
        secondList: {
          height: 0,
          list: []
        }
      },
      pageModel: {
        page: 0,
        pageSize: 20
      },
      appCont: YunJi.getUrlParams('appCont') || 0,
      ticket: YunJi.getUrlParams('ticket') || '',
      gray: null
    }
  },
  async mounted() {
    await this.queryGrayAndBottomBar()
    this.queryPageModuleTabRecommend()
  },
  beforeDestroy() {
    this.moduleLeave()
  },
  methods: {
    ...mapMutations(['SETNRECOMMDRREQ']),
    initData() {
      this.modulesDataList = []
      this.modulesList = {
        firstList: {
          height: 0,
          list: []
        },
        secondList: {
          height: 0,
          list: []
        }
      }
      this.pageModel.page = 0
      this.hasMore = true
    },
    loadBottom() {
      if (!this.hasMore) return
      this.pageModel.page += 1
      this.queryPageModuleTabRecommend()
    },
    async queryGrayAndBottomBar() {
      try {
        const { data } = await service.queryGrayAndBottomBar({
          appCont: this.appCont,
          ticket: this.ticket,
          version: 1
        })
        this.gray = data
      } catch (error) {
        console.error('获取灰度字段失败 error：', error)
        this.gray = ''
      }
    },
    async queryPageModuleTabRecommend() {
      const params = {
        appCont: this.appCont,
        ticket: this.ticket,
        ...this.pageModel,
        strVersion: 2,
        tabId: this.categoryId
      }
      if (this.gray && this.gray.homepageGray) {
        params.gray = `recommendForNewItem_${this.gray.homepageGray.recommendForNewItem}`
      }
      service.queryPageModuleTabRecommend(params).then((res) => {
        if (res.errorCode === 0) {
          const resData = res.data || []
          if (resData.length === 0) {
            this.hasMore = false
          } else {
            this.createList(MarkeUtil.setMarkeLabelByItemsListNew(resData, false, this.appCont, 9))
          }
        }
      })
    },
    // 瀑布流分流
    createList(arr) {
      const firstList = []
      let firstHeight = this.modulesList.firstList.height
      const secondList = []
      let secondHeight = this.modulesList.secondList.height
      arr.forEach((item, index) => {
        // 店铺关注人数，大于100则显示，小于则不显示
        if (item.type === 1 && item.followNum < 100) {
          return 
        }
        // 若商品小于3个则不显示榜单模块
        if (item.type === 2 && (!Array.isArray(item.rankItemBos) || item.rankItemBos.length < 3)) {
          return
        }
        // 那边低分到哪边 第一列优先
        if (firstHeight <= secondHeight) {
          firstList.push(item)
          item.$index = index
          firstHeight += itemHeight[item.type]
        } else {
          secondList.push(item)
          item.$index = index
          secondHeight += itemHeight[item.type]
        }
      })
      this.modulesList.firstList.list = this.modulesList.firstList.list.concat(firstList)
      this.modulesList.firstList.height = firstHeight
      this.modulesList.secondList.list = this.modulesList.secondList.list.concat(secondList)
      this.modulesList.secondList.height = secondHeight
      this.SETNRECOMMDRREQ(firstHeight > 0 && secondHeight > 0 ? 0 : 3)
    },
    // 所有卡片的跳转整合
    toDetail(jumpData) {
      let ABtestId = ''
      if (this.gray && this.gray.homepageGray && this.gray.homepageGray.recommendForNewItem) {
        ABtestId = this.gray.homepageGray.recommendForNewItem
      }
      // 【新品+类目】为你推荐点击
      window.thinkingReport.track('click_list', {
        page_id: 10294,
        point_id: 28619,
        index: jumpData.index + 1,
        ...createTrackObj(jumpData.jumpType, jumpData.jumpValue),
        tab_name: this.parentLevelName,
        module_name: 'banner',
        ABtestId: ABtestId
      })
      jumpData.appCont = this.appCont
      jumpData.shopId = this.shopId
      jumpHandle(jumpData, this.appCont)
    },
    moduleLeave() {
      let ABtestId = ''
      if (this.gray && this.gray.homepageGray && this.gray.homepageGray.recommendForNewItem) {
        ABtestId = this.gray.homepageGray.recommendForNewItem
      }
      const arr = this.modulesList.firstList.list.concat(this.modulesList.secondList.list).map((item) => {
        // jumpType 0无跳转 1专题 2商品 3网址 4品牌团 5直播 6主播 7榜单 8店铺编码
        // item.type 0商品 1店铺 2榜单 3专题
        if (item.type === 0) return { jumpType: 2, jumpValue: item.itemId }
        if (item.type === 1) return { jumpType: 8, jumpValue: item.storeCode }
        if (item.type === 2) return { jumpType: 7, jumpValue: item.recommendId }
        return { jumpType: 1, jumpValue: item.recommendId }
      })
      const contentIdStr = createTrackContentIdList(arr)
      // 【新品】99新品离开曝光
      window.thinkingReport.track('exposure', {
        page_id: 10294,
        point_id: 28620,
        content_type: '离开曝光',
        content_id: contentIdStr,
        tab_name: this.parentLevelName,
        index: Math.max(this.modulesList.firstList.list.length, this.modulesList.secondList.list.length),
        module_name: '为你推荐',
        ABtestId: ABtestId
      })
    }
  }
}
</script>
<style lang="less" scoped>
.recommend-list {
  width: 100%;
  background-color: #fff;
  border-radius: .08rem;
  padding-bottom: .16rem;
  .header-text {
    padding: .3rem .16rem .14rem .16rem;
    font-family: PingFangSC-Semibold;
    font-size: .28rem;
    color: #262626;
    display: flex;
    align-items: center;
    img {
      width: .32rem;
      height: .32rem;
      margin-right: .12rem;
    }
  }
  .recommend-list-container {
    margin: 0 .07rem;
    display: flex;
    justify-content: center;
    .row-container {
      // margin: 0 .09rem;
      .item-container {
        margin: .16rem 0;
      }
    }
  }
  .more-text {
    padding: .2rem;
    font-size: 0.24rem;
    color: #bbb;
    text-align: center;
  }
}
</style>
